import { useState, useEffect } from 'react';

export function webPCheck() {
    return new Promise((resolve) => {
        const image = new Image();
        image.onerror = function() {
            return resolve(false);
        };
        image.onload = function() {
            return resolve(image.width === 1);
        };
        image.src =
            'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';
    }).catch(() => false);
}

export default function useWebPCheckSupport() {
    const [{ webP: supportsWebP }, setWebPSupport] = useState({ webP: true });

    useEffect(() => {
        const checkForSupport = async () => {
            const browserSupportsWebP = await webPCheck();

            setWebPSupport({ webP: browserSupportsWebP });
        };

        checkForSupport();
    }, []);

    return supportsWebP;
}
